// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__ba51604460052d29b886","cls2":"ImpactHubModal-cls2__c0d6902959b737abf4de ImpactHubModal-cls1__ba51604460052d29b886"};